import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysAgo',
})
export class DaysAgoPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (!value) {
      return '';
    }

    const createdDate = new Date(value);
    const today = new Date();

    if (isNaN(createdDate.getTime())) {
      return '';
    }

    // Use UTC for consistent day difference calculation, avoiding DST issues
    const createdDateUTC = Date.UTC(createdDate.getFullYear(), createdDate.getMonth(), createdDate.getDate());
    const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

    const differenceInTime = todayUTC - createdDateUTC;

    const msInDay = 1000 * 60 * 60 * 24;
    const daysAgo = Math.floor(differenceInTime / msInDay);

    if (daysAgo === 0) {
      return '(today)';
    } else if (daysAgo > 0) {
      return `(${daysAgo} days ago)`;
    } else {
      // Date is in the future
      return '';
    }
  }
}
